module.exports = "<div class=\"row align-items-center message\">\r\n  <div class=\"col text-center\">\r\n    <p class=\"text-uppercase\">{{errorTitle}}</p>\r\n    <i class=\"orbit-editor orbit-editor-error\"></i>\r\n    <p>{{errorMessage}}</p>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error/error.component.html
// module id = ./src/app/components/error/error.component.html
// module chunks = main